import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { withRouter } from "react-router-dom"
import moment from "moment"
import { amountFormatter } from "helpers/util"
import LazyLoadWrapper from "components/common/LazyLoadWrapper"
import MediaPlayer from "components/common/MediaPlayer"
import ImagePlaceholder from "assets/images/imageplaceholder.png"
import history from "app/history"
import "styles/pages/landing.scss"
import "react-lazy-load-image-component/src/effects/blur.css"

class Featured extends Component {
  goToFeatured() {
    const { featuredCourse } = this.props

    if (featuredCourse.type === "bundle") {
      history.push(`/course-bundle/${featuredCourse.slug}`)
    } else {
      history.push(`/course/${featuredCourse.slug}`)
    }
  }

  getMediaType = () => {
    const { featuredCourse } = this.props
    let mediaType = ""
    if (featuredCourse.preview_video != null) {
      mediaType = "video"
    } else {
      mediaType = "image"
    }
    return mediaType
  }

  getMediaProgress = (value) => {
    this.setState({ mediaProgress: value })
  }

  renderMedia = () => {
    const { featuredCourse } = this.props || {}
    const videoPreview = featuredCourse.preview_video
    const imagePreview = featuredCourse.image
    const YT_URL = "https;//youtube.com/watch?v="
    switch (this.getMediaType()) {
      case "image":
        return (
          <LazyLoadWrapper
            className="image"
            src={`${imagePreview || ImagePlaceholder}`}
            effect="blur"
          />
        )
      case "video":
        return (
          <Fragment>
            <MediaPlayer
              media={
                videoPreview?.type === "yt"
                  ? YT_URL + `${videoPreview?.url}`
                  : `${videoPreview?.url}`
              }
              onGetMediaProgress={this.getMediaProgress}
              type={videoPreview?.type}
              forwardStreaming={true}
              customStyle={{ marginBottom: "0px" }}
            />
          </Fragment>
        )
      default:
        return
    }
  }

  render() {
    const { featuredCourse } = this.props || {}
    return (
      <>
        <div
          className="featured-section -details"
          style={{ borderTopColor: featuredCourse.primary_color }}
        >
          <p className="date">
            <span className="icon-calendar" />
            {moment(featuredCourse.created_at).format("d MMMM yyyy")}
          </p>
          <h1 className="name">{featuredCourse.name}</h1>
          <p className="description">{featuredCourse.description}</p>

          <button className="button" onClick={() => this.goToFeatured()}>
            {featuredCourse.fee ? (
              <span className="fee">{`P${amountFormatter(
                featuredCourse.fee
              )}`}</span>
            ) : (
              <span className="fee -free">Free</span>
            )}
            View {featuredCourse.type === "bundle" ? "Bundle" : "Course"}
            <span className="icon-right" />
          </button>
        </div>
        <div className="featured-section">{this.renderMedia()}</div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
})

export default compose(connect(mapStateToProps), withRouter)(Featured)
